"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetBonuscodeNoBonuscodesError = void 0;
var setbonuscode_1 = __importDefault(require("./setbonuscode"));
// Re-Export of default export is not possible, so we MUST export it named
// eslint-disable-next-line import/prefer-default-export
var SetBonuscodeNoBonuscodesError = /** @class */ (function (_super) {
    __extends(SetBonuscodeNoBonuscodesError, _super);
    function SetBonuscodeNoBonuscodesError(bonuscodeOnBasket, message) {
        var _this = _super.call(this, bonuscodeOnBasket, message) || this;
        Object.setPrototypeOf(_this, SetBonuscodeNoBonuscodesError.prototype);
        return _this;
    }
    return SetBonuscodeNoBonuscodesError;
}(setbonuscode_1.default));
exports.SetBonuscodeNoBonuscodesError = SetBonuscodeNoBonuscodesError;
//# sourceMappingURL=setbonuscodenobonuscodes.js.map